import MethodologyAnchor from '../MethodologyAnchor';
import {
  StyledContainer,
  StyledTable,
  StyledValue
} from './AverageSalaryByRole.styled';

const AverageSalaryByRole: React.FC = () => {
  const data = [
    {
      role: 'Backend Developer',
      tier2: 17.255717255717258,
      tier3: 21.933471933471935,
      tier4: 24.636174636174637,
      tier5: 15.557865557865558,
      tier6: 10.94941094941095,
      tier7: 3.6036036036036037,
      tier1: 6.063756063756063
    },
    {
      role: 'Full-stack Developer',
      tier2: 22.491349480968857,
      tier3: 23.26989619377163,
      tier4: 22.318339100346023,
      tier5: 13.278546712802768,
      tier6: 8.780276816608996,
      tier7: 2.63840830449827,
      tier1: 7.2231833910034595
    },
    {
      role: 'Frontend Developer',
      tier2: 28.84259259259259,
      tier3: 22.824074074074076,
      tier4: 17.453703703703706,
      tier5: 10.416666666666668,
      tier6: 6.5740740740740735,
      tier7: 1.8518518518518516,
      tier1: 12.037037037037036
    },
    {
      role: 'Mobile Developer',
      tier2: 19.20374707259953,
      tier3: 22.716627634660423,
      tier4: 18.26697892271663,
      tier5: 15.22248243559719,
      tier6: 12.177985948477751,
      tier7: 4.449648711943794,
      tier1: 7.962529274004685
    },
    {
      role: 'Software Architect',
      tier2: 5.982905982905983,
      tier3: 9.572649572649574,
      tier4: 21.70940170940171,
      tier5: 24.957264957264957,
      tier6: 25.299145299145298,
      tier7: 10.76923076923077,
      tier1: 1.7094017094017095
    },
    {
      role: 'DevOps & Infrastructure & SRE',
      tier2: 10.416666666666668,
      tier3: 15.384615384615385,
      tier4: 23.23717948717949,
      tier5: 21.474358974358974,
      tier6: 19.391025641025642,
      tier7: 7.211538461538461,
      tier1: 2.8846153846153846
    },
    {
      role: 'SysAdmin',
      tier2: 19.753086419753085,
      tier3: 28.80658436213992,
      tier4: 22.22222222222222,
      tier5: 13.580246913580247,
      tier6: 7.818930041152264,
      tier7: 2.05761316872428,
      tier1: 5.761316872427984
    },
    {
      role: 'Brand Design',
      tier2: 26.82926829268293,
      tier3: 30.48780487804878,
      tier4: 9.75609756097561,
      tier5: 12.195121951219512,
      tier6: 2.4390243902439024,
      tier7: 2.4390243902439024,
      tier1: 15.853658536585366
    },
    {
      role: 'Product Manager',
      tier2: 5.83756345177665,
      tier3: 17.00507614213198,
      tier4: 20.304568527918782,
      tier5: 23.096446700507613,
      tier6: 25.63451776649746,
      tier7: 7.868020304568528,
      tier1: 0.25380710659898476
    },
    {
      role: 'Data Analysis & BI',
      tier2: 21.428571428571427,
      tier3: 23.91304347826087,
      tier4: 23.91304347826087,
      tier5: 14.906832298136646,
      tier6: 9.316770186335404,
      tier7: 2.484472049689441,
      tier1: 4.037267080745342
    },
    {
      role: 'QA & Testing Engineer',
      tier2: 23.076923076923077,
      tier3: 21.428571428571427,
      tier4: 20.87912087912088,
      tier5: 15.934065934065933,
      tier6: 9.89010989010989,
      tier7: 2.197802197802198,
      tier1: 6.593406593406594
    },
    {
      role: 'Project Manager & Delivery Manager',
      tier2: 6.839186691312385,
      tier3: 12.384473197781885,
      tier4: 22.920517560073936,
      tier5: 24.214417744916823,
      tier6: 26.98706099815157,
      tier7: 6.654343807763401,
      tier1: 0
    },
    {
      role: 'Data Scientist',
      tier2: 21.48997134670487,
      tier3: 24.355300859598856,
      tier4: 19.484240687679083,
      tier5: 15.759312320916905,
      tier6: 9.742120343839542,
      tier7: 4.297994269340974,
      tier1: 4.871060171919771
    },
    {
      role: 'Data Engineer',
      tier2: 13.58974358974359,
      tier3: 21.28205128205128,
      tier4: 21.025641025641026,
      tier5: 20.76923076923077,
      tier6: 16.666666666666664,
      tier7: 4.358974358974359,
      tier1: 2.307692307692308
    },
    {
      role: 'Engineering Management',
      tier2: 2.9213483146067416,
      tier3: 4.269662921348314,
      tier4: 12.584269662921349,
      tier5: 22.02247191011236,
      tier6: 37.52808988764045,
      tier7: 20,
      tier1: 0.6741573033707865
    },
    {
      role: 'Tech Lead',
      tier2: 1.532567049808429,
      tier3: 7.535121328224776,
      tier4: 19.923371647509576,
      tier5: 26.56449553001277,
      tier6: 29.88505747126437,
      tier7: 14.17624521072797,
      tier1: 0.38314176245210724
    }
  ];

  const getClassColor = (val: number): string => {
    if (val === 0) {
      return 'cell-color-1';
    }
    if (val > 0 && val <= 5) {
      return 'cell-color-2';
    }
    if (val > 5 && val <= 9) {
      return 'cell-color-3';
    }
    if (val > 9 && val <= 14) {
      return 'cell-color-4';
    }
    if (val > 14 && val <= 19) {
      return 'cell-color-5';
    }
    if (val > 19 && val <= 24) {
      return 'cell-color-6';
    }
    if (val > 24 && val <= 29) {
      return 'cell-color-7';
    }
    if (val > 29) {
      return 'cell-color-8';
    } else {
      return 'cell-color-1';
    }
  };

  return (
    <StyledContainer>
      <StyledTable>
        <thead>
          <tr>
            <th></th>
            <th>&lt;20K</th>
            <th>€20-30K</th>
            <th>€31-40K</th>
            <th>€41-50K</th>
            <th>€51-60K</th>
            <th>€61-80K</th>
            <th>&gt;80K</th>
          </tr>
        </thead>
        <tbody>
          {data.map((data, index) => (
            <tr key={index}>
              <th>{data.role}</th>
              <td>
                <StyledValue className={getClassColor(data.tier1)}>
                  {data.tier1.toFixed(1)}%
                </StyledValue>
              </td>
              <td>
                <StyledValue className={getClassColor(data.tier2)}>
                  {data.tier2.toFixed(1)}%
                </StyledValue>
              </td>
              <td>
                <StyledValue className={getClassColor(data.tier3)}>
                  {data.tier3.toFixed(1)}%
                </StyledValue>
              </td>
              <td>
                <StyledValue className={getClassColor(data.tier4)}>
                  {data.tier4.toFixed(1)}%
                </StyledValue>
              </td>
              <td>
                <StyledValue className={getClassColor(data.tier5)}>
                  {data.tier5.toFixed(1)}%
                </StyledValue>
              </td>
              <td>
                <StyledValue className={getClassColor(data.tier6)}>
                  {data.tier6.toFixed(1)}%
                </StyledValue>
              </td>
              <td>
                <StyledValue className={getClassColor(data.tier7)}>
                  {data.tier7.toFixed(1)}%
                </StyledValue>
              </td>
            </tr>
          ))}
        </tbody>
      </StyledTable>
      <MethodologyAnchor />
    </StyledContainer>
  );
};

export default AverageSalaryByRole;
